var map = {
  "./": "./packages/core/src/client/index.ts",
  "./client": "./packages/core/src/client/client.ts",
  "./client.ts": "./packages/core/src/client/client.ts",
  "./dom/attr": "./packages/core/src/client/dom/attr.ts",
  "./dom/attr.ts": "./packages/core/src/client/dom/attr.ts",
  "./dom/beacon": "./packages/core/src/client/dom/beacon.ts",
  "./dom/beacon.ts": "./packages/core/src/client/dom/beacon.ts",
  "./dom/cookie": "./packages/core/src/client/dom/cookie.ts",
  "./dom/cookie.ts": "./packages/core/src/client/dom/cookie.ts",
  "./dom/css": "./packages/core/src/client/dom/css.ts",
  "./dom/css.ts": "./packages/core/src/client/dom/css.ts",
  "./dom/document": "./packages/core/src/client/dom/document.ts",
  "./dom/document.ts": "./packages/core/src/client/dom/document.ts",
  "./dom/element": "./packages/core/src/client/dom/element.ts",
  "./dom/element.ts": "./packages/core/src/client/dom/element.ts",
  "./dom/fontface": "./packages/core/src/client/dom/fontface.ts",
  "./dom/fontface.ts": "./packages/core/src/client/dom/fontface.ts",
  "./dom/fragments": "./packages/core/src/client/dom/fragments.ts",
  "./dom/fragments.ts": "./packages/core/src/client/dom/fragments.ts",
  "./dom/history": "./packages/core/src/client/dom/history.ts",
  "./dom/history.ts": "./packages/core/src/client/dom/history.ts",
  "./dom/open": "./packages/core/src/client/dom/open.ts",
  "./dom/open.ts": "./packages/core/src/client/dom/open.ts",
  "./dom/origin": "./packages/core/src/client/dom/origin.ts",
  "./dom/origin.ts": "./packages/core/src/client/dom/origin.ts",
  "./dom/performance": "./packages/core/src/client/dom/performance.ts",
  "./dom/performance.ts": "./packages/core/src/client/dom/performance.ts",
  "./dom/protocol": "./packages/core/src/client/dom/protocol.ts",
  "./dom/protocol.ts": "./packages/core/src/client/dom/protocol.ts",
  "./dom/storage": "./packages/core/src/client/dom/storage.ts",
  "./dom/storage.ts": "./packages/core/src/client/dom/storage.ts",
  "./entry": "./packages/core/src/client/entry.ts",
  "./entry.ts": "./packages/core/src/client/entry.ts",
  "./events": "./packages/core/src/client/events.ts",
  "./events.ts": "./packages/core/src/client/events.ts",
  "./helpers": "./packages/core/src/client/helpers.ts",
  "./helpers.ts": "./packages/core/src/client/helpers.ts",
  "./index": "./packages/core/src/client/index.ts",
  "./index.ts": "./packages/core/src/client/index.ts",
  "./location": "./packages/core/src/client/location.ts",
  "./location.ts": "./packages/core/src/client/location.ts",
  "./shared/antiantidebugger": "./packages/core/src/client/shared/antiantidebugger.ts",
  "./shared/antiantidebugger.ts": "./packages/core/src/client/shared/antiantidebugger.ts",
  "./shared/blob": "./packages/core/src/client/shared/blob.ts",
  "./shared/blob.ts": "./packages/core/src/client/shared/blob.ts",
  "./shared/caches": "./packages/core/src/client/shared/caches.ts",
  "./shared/caches.ts": "./packages/core/src/client/shared/caches.ts",
  "./shared/chrome": "./packages/core/src/client/shared/chrome.ts",
  "./shared/chrome.ts": "./packages/core/src/client/shared/chrome.ts",
  "./shared/err": "./packages/core/src/client/shared/err.ts",
  "./shared/err.ts": "./packages/core/src/client/shared/err.ts",
  "./shared/error": "./packages/core/src/client/shared/error.ts",
  "./shared/error.ts": "./packages/core/src/client/shared/error.ts",
  "./shared/eval": "./packages/core/src/client/shared/eval.ts",
  "./shared/eval.ts": "./packages/core/src/client/shared/eval.ts",
  "./shared/event": "./packages/core/src/client/shared/event.ts",
  "./shared/event.ts": "./packages/core/src/client/shared/event.ts",
  "./shared/function": "./packages/core/src/client/shared/function.ts",
  "./shared/function.ts": "./packages/core/src/client/shared/function.ts",
  "./shared/import": "./packages/core/src/client/shared/import.ts",
  "./shared/import.ts": "./packages/core/src/client/shared/import.ts",
  "./shared/indexeddb": "./packages/core/src/client/shared/indexeddb.ts",
  "./shared/indexeddb.ts": "./packages/core/src/client/shared/indexeddb.ts",
  "./shared/opfs": "./packages/core/src/client/shared/opfs.ts",
  "./shared/opfs.ts": "./packages/core/src/client/shared/opfs.ts",
  "./shared/postmessage": "./packages/core/src/client/shared/postmessage.ts",
  "./shared/postmessage.ts": "./packages/core/src/client/shared/postmessage.ts",
  "./shared/realm": "./packages/core/src/client/shared/realm.ts",
  "./shared/realm.ts": "./packages/core/src/client/shared/realm.ts",
  "./shared/requests/eventsource": "./packages/core/src/client/shared/requests/eventsource.ts",
  "./shared/requests/eventsource.ts": "./packages/core/src/client/shared/requests/eventsource.ts",
  "./shared/requests/fetch": "./packages/core/src/client/shared/requests/fetch.ts",
  "./shared/requests/fetch.ts": "./packages/core/src/client/shared/requests/fetch.ts",
  "./shared/requests/websocket": "./packages/core/src/client/shared/requests/websocket.ts",
  "./shared/requests/websocket.ts": "./packages/core/src/client/shared/requests/websocket.ts",
  "./shared/requests/xmlhttprequest": "./packages/core/src/client/shared/requests/xmlhttprequest.ts",
  "./shared/requests/xmlhttprequest.ts": "./packages/core/src/client/shared/requests/xmlhttprequest.ts",
  "./shared/settimeout": "./packages/core/src/client/shared/settimeout.ts",
  "./shared/settimeout.ts": "./packages/core/src/client/shared/settimeout.ts",
  "./shared/sourcemaps": "./packages/core/src/client/shared/sourcemaps.ts",
  "./shared/sourcemaps.ts": "./packages/core/src/client/shared/sourcemaps.ts",
  "./shared/worker": "./packages/core/src/client/shared/worker.ts",
  "./shared/worker.ts": "./packages/core/src/client/shared/worker.ts",
  "./shared/wrap": "./packages/core/src/client/shared/wrap.ts",
  "./shared/wrap.ts": "./packages/core/src/client/shared/wrap.ts",
  "./singletonbox": "./packages/core/src/client/singletonbox.ts",
  "./singletonbox.ts": "./packages/core/src/client/singletonbox.ts",
  "./worker/importScripts": "./packages/core/src/client/worker/importScripts.ts",
  "./worker/importScripts.ts": "./packages/core/src/client/worker/importScripts.ts"
};


function __rspack_context(req) {
  var id = __rspack_context_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context.keys = function webpackContextKeys() {
  return Object.keys(map);
};
__rspack_context.resolve = __rspack_context_resolve;
module.exports = __rspack_context;
__rspack_context.id = "./packages/core/src/client sync recursive ^\\.\\/.*$";
